import { render, staticRenderFns } from "./BookingEdit.vue?vue&type=template&id=10fc2e50&scoped=true&lang=html&"
import script from "./BookingEdit.vue?vue&type=script&lang=js&"
export * from "./BookingEdit.vue?vue&type=script&lang=js&"
import style0 from "./BookingEdit.vue?vue&type=style&index=0&id=10fc2e50&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc2e50",
  null
  
)

export default component.exports